import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2350165087/src/cloudix/src/app/components/layoutManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CountriesProvider"] */ "/codebuild/output/src2350165087/src/cloudix/src/app/contexts/CountriesContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationProvider"] */ "/codebuild/output/src2350165087/src/cloudix/src/app/contexts/TranslationContext.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2350165087/src/cloudix/src/app/globals.css");
